import { Card, Grid, Paper, Typography, Link, CardContent, Stack, TextField, TableHead, TableCell, TableRow, Table, TableBody, Box, Tooltip, Button, TableContainer, Checkbox, CardHeader } from '@mui/material';
import React, { useState } from 'react';
import Loading from '../../components/Loading';
import { useRecachePOSheetMutation } from '../../features/po/poSlice';
import { UploadJDBox } from '../../pages/po/UploadJDBox';

const LCCDash = () => {
    const [recache, {isLoading: recaching}] = useRecachePOSheetMutation();
    let recacheButton = recaching ?
        <Loading />
        :
        <Button variant={"contained"} onClick={() => {recache()}}>Re-cache PO sheet</Button>;
        
    return <Paper><Card>
        <CardHeader title="LCC Functions" titleTypographyProps={{variant: "h2"}} subheader="" />
        <CardContent>
            <Stack direction="column" spacing={2}>
            {recacheButton}
            <UploadJDBox />
            <Link href={`${process.env.REACT_APP_PREFIX}/purchaseorder`} underline='none'>PO sheet</Link>
            </Stack>
        </CardContent>
        </Card></Paper>
}

export { LCCDash };